<template>
  <div :class="'decimalDisabled ' + (isDarkTheme ? 'is_dark' :'is_light')" :style="''+css">
    {{prefix}} {{ valueWithMaskMoney() }} {{sufix}}
  </div>
</template>

<script>

import {mascaraValor} from '../../components/pComponents/commons/misc'
import {mapState} from "vuex";

export default {
  name: 'pLabel',
  props: {
    css: {
      default: ''
    },
    sufix: {
      default: ''
    },
    prefix: {
      default: ''
    },
    name: {
      type: String
    },
    value: {
      default: 0
    }
  },
  methods: {
    valueWithMaskMoney() {
      return mascaraValor(this.value)
    }
  },
  computed:{
    ...mapState('geral', {isDarkTheme: 'isDarkTheme'}),
  },
}
</script>
<style>

</style>

